<template>
  <div class="expandable"
    ref="trigger">
    <a class="link--read-more link--read-more-left"
      @click="toggle">
      <lennoc-icon image="chevron-bottom" domclass="icon--circled"></lennoc-icon>
      <span>{{ label }}</span>
    </a>
    <div class="expandable__content" ref="content">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { onMounted, ref } from 'vue'

  const props = defineProps({
    label: {
      type: String,
      required: true
    }
  })

  const emits = defineEmits([
    'triggered'
  ])

  onMounted(() => {
    height = content.value.clientHeight
    content.value.style.height = '0px'
  })

  const content = ref()
  const trigger = ref()

  let height = ''
  let open = false

  const toggle = () => {
    if (open) {
      content.value.style.height = content.value.clientHeight + 'px'
      trigger.value.classList.remove('expandable__triggered')
      content.value.style.height = '0px'
      open = false
      emits('triggered')
      return
    }
    trigger.value.classList.add('expandable__triggered')
    content.value.style.height = height + 'px'

    setTimeout(() => {
        if(open)
          content.value.style.height = 'auto'
      }, 500);

    open = true
    emits('triggered')
  }

</script>
